import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewEncapsulation,
} from "@angular/core";
import {NG_VALUE_ACCESSOR, ControlValueAccessor} from "@angular/forms";
declare let require: any;
const Quill = require("quill");

@Component({
  selector: "quill-editor",
  template: `<div class="quill-editor"></div>`,
  styleUrls: [
    "./quill-editor.component.css",
    "../../../node_modules/quill/dist/quill.core.css",
    "../../../node_modules/quill/dist/quill.snow.css",
    "../../../node_modules/quill/dist/quill.bubble.css"
  ],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QuillEditorComponent),
    multi: true,
  }],
  encapsulation: ViewEncapsulation.None
})
export class QuillEditorComponent implements AfterViewInit, ControlValueAccessor, OnChanges {
  quillEditor: any;
  editorElem: HTMLElement;
  content: any;
  defaultModules = {
    toolbar: [
      ["bold", "italic", "underline", "strike"],
      ["blockquote", "code-block"],
      [{"header": 1}, {"header": 2}],
      [{"list": "ordered"}, {"list": "bullet"}],
      [{"script": "sub"}, {"script": "super"}],
      [{"indent": "-1"}, {"indent": "+1"}],
      [{"direction": "rtl"}],
      [{"size": ["small", false, "large", "huge"]}],
      [{"header": [1, 2, 3, 4, 5, 6, false] }],
      [{"color": [] as Array<any>}, {"background": [] as Array<any>}],
      [{"font": [] as Array<any>}],
      [{"align": [] as Array<any>}],
      ["clean"],
      ["link"/*, "image", "video"*/],
    ],
  };

  @Input() options: Object;

  @Output() blur: EventEmitter<any> = new EventEmitter();
  @Output() focus: EventEmitter<any> = new EventEmitter();
  @Output() ready: EventEmitter<any> = new EventEmitter();
  @Output() change: EventEmitter<any> = new EventEmitter();

  onModelChange: Function = () => {};
  onModelTouched: Function = () => {};

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit() {
    this.editorElem = this.elementRef.nativeElement.children[0];

    this.quillEditor = new Quill(
      this.editorElem,
      {
        modules: this.defaultModules,
        placeholder: "Insert text here ...",
        readOnly: false,
        theme: "snow",
        boundary: document.body,
        ...(this.options || {}),
      },
    );

    if (this.content) {
      this.quillEditor.pasteHTML(this.content);
    }

    this.ready.emit(this.quillEditor);

    // mark model as touched if editor lost focus
    this.quillEditor.on("selection-change", (range: any) => {
      if (!range) {
        this.onModelTouched();
        this.blur.emit(this.quillEditor);
      } else {
        this.focus.emit(this.quillEditor);
      }
    });

    // update model if text changes
    this.quillEditor.on("text-change", (delta: any, oldDelta: any, source: any) => {
      let html = this.editorElem.children[0].innerHTML;
      const text = this.quillEditor.getText();

      if (html === '') html = null;

      this.onModelChange(html);

      this.change.emit({
        editor: this.quillEditor,
        html: html,
        text: text
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["readOnly"] && this.quillEditor) {
      this.quillEditor.enable(!changes["readOnly"].currentValue);
    }
  }

  writeValue(currentValue: any) {
    this.content = currentValue;

    if (this.quillEditor) {
      if (currentValue) {
        this.quillEditor.pasteHTML(currentValue);
        return;
      }
      this.quillEditor.setText("");
    }
  }

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }
}



// WEBPACK FOOTER //
// /var/snowriders/app/src/app/ngx-quill-editor/quill-editor.component.ts